export enum Theme {
    none = 0,
    system = 1,
    light = 2,
    dark = 3,
}
